<template>
  <div id="orderCompleted">
    <div  v-if="!getMobile" id="navigation">
      <div style="position: relative;">
        <Navigation />
      </div>
    </div>
    <div v-if="getMobile">
      <NavigationMobile />
    </div>

    <div :class="{centerElement : !getMobile, mobile : getMobile}">
      <div>
      </div>
      <div style="padding-top: 70px;">
        <h3>
          {{getText.cart.orderSuccess}}
        </h3>
        <div id="purchaseInfoWrapper">
          <h2>Überblick deiner Bestellung</h2>
          <div :class="{purchaseInfo: !getMobile}">
            <div>
              <CartProductList :position="completed" />
            </div>
            <div v-if="!getMobile" style="position: relative;">
              <div style="position: absolute; bottom: 10px; right:0;">
                <h3 style="text-align: right">Gesamtbetrag: <span id="priceOrderCompleted">{{getOrder.totalPrice}}</span>€</h3>
                <h3 style="text-align: right">Bestellnummer: {{getOrder.orderID}}</h3>
              </div>
            </div>
            <div v-if="getMobile" style="position: relative; height: 60px;">
              <div style="position: absolute; bottom: 10px; left:0;">
                <h3 style="text-align: left">Gesamtbetrag: <span id="priceOrderCompleted">{{getOrder.totalPrice}}</span>€</h3>
                <h3 style="text-align: left">Bestellnummer: {{getOrder.orderID}}</h3>
              </div>
            </div>
          </div>
        </div>
        <div style="position: relative; top: 40px;">
          <h2>{{getText.cart.originTitle}}</h2>
          <v-radio-group v-model="customerOrigin.normalOrigin" column >
            <v-radio :label="getText.cart.originFacebook" color="var(--accentColor)" value="facebook" >

            </v-radio>
            <v-radio :label="getText.cart.originInstagram" color="var(--accentColor)" value="instagram" >

            </v-radio>
            <v-radio :label="getText.cart.originGoogle" color="var(--accentColor)" value="google" >

            </v-radio>
            <v-radio :label="getText.cart.originFriends" color="var(--accentColor)" value="friends" >

            </v-radio>
            <v-text-field :label="getText.cart.originOther" color="var(--accentColor)" v-model="customerOrigin.otherOrigin">

            </v-text-field>
          </v-radio-group>
          <v-btn @click="sendCustomerOrigin()" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.cart.originSubmit}}</span>
          </v-btn>
        </div>
      </div>
      <div>
      </div>
    </div>

  </div>
</template>

<script>
  import Navigation from '@/components/Navigation.vue'
  import NavigationMobile from '@/components/NavigationMobile.vue'
  import CartProductList from '@/components/CartProductList.vue'
  import router from '@/router/index.js'
  import { ecommerce } from 'vue-analytics'

export default {
  name: 'orderCompleted',
  components: {
    Navigation,
    CartProductList,
    NavigationMobile
  },
  data() {
    return{
      customerOrigin: {normalOrigin: "", otherOrigin:""},
    }
   },
   computed: {
     getCheckoutEnabler(){return this.$store.state.voucher.vouchers[2].used},
     getText(){return this.$store.getters.getText},
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getOrder(){ return this.$store.getters.getOrder; }
   },
   methods: {
     sendCustomerOrigin(){
       this.$store.dispatch("sendMessage", this.customerOrigin);
       router.push('/')
     },
   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 6);
     window.scrollTo(0, 0)

     ecommerce.addTransaction({
        id: this.getOrder.orderID,
        price: this.getOrder.totalPrice
      })

      ecommerce.send()

     // this.$ga.ecommerce.addTransaction({
     //      id: this.getOrder.orderID,
     //      price: this.getOrder.totalPrice
     //    })
     // this.$ga.ecommerce.send()
   },
}
</script>

<style scoped>
#purchaseInfoWrapper{
  background-color: var(--accentColorShaded);
  padding: 30px 15px;
  margin: 50px 0;
}
.purchaseInfo{
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-top: 15px;
  }
.checkoutDesktop{
  max-width: 350px;
  box-sizing: content-box;
  padding: 0 100px;
}
.cardWrapper{
  margin: 15px 0;
}
.card{
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr;
  padding: 15px 10px 15px 0;
}
  .mobile{
    margin: 0 10px;
  }
  #orderCompleted {
    position: relative;
    top: var(--desktopNavigationHeight);
    padding-bottom: 60px;
  }
  #cartMain {
    min-height: calc(90vh - var(--desktopNavigationHeight));
  }
  #cancelled{
    width: 285px;
    background-color: #F99;
    margin: auto;
    padding: 20px 0;
  }

</style>
